/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Manage_Roles_DescriptionInputs */

const en_admin_users_manage_roles_description = /** @type {(inputs: Admin_Users_Manage_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign or remove roles for this user`)
};

const zh_admin_users_manage_roles_description = /** @type {(inputs: Admin_Users_Manage_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为此用户分配或移除角色`)
};

/**
* | output |
* | --- |
* | "Assign or remove roles for this user" |
*
* @param {Admin_Users_Manage_Roles_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_manage_roles_description = /** @type {((inputs?: Admin_Users_Manage_Roles_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Manage_Roles_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_manage_roles_description(inputs)
	return zh_admin_users_manage_roles_description(inputs)
});
export { admin_users_manage_roles_description as "admin.users.manage_roles_description" }